import React from 'react';
import {
  BACKEND_DEFAULT_THRESHOLD,
  RECURRENCE_CUSTOM,
  RECURRENCE_DEFAULT,
  RECURRENCE_UNITS,
  RECURRENCE_UNIT_LABELS,
} from '../../../utils/ruleRecurrence';
import { pluralRu, EVENT_FORMS } from '../../../utils/pluralRu';

export const UNKNOWN_UNIT_LABEL = 'Единица не поддерживается';

/**
 * Политика повторяемости правила (ТЗ §33, FE-FIX30).
 *
 * Режим «По умолчанию» оставляет тройку recurrence-полей пустой: backend сам
 * решает, каким окном считать повторяемость в конкретном контексте. Поэтому
 * подсказка не называет окно — фронт его не знает и не имеет права выдумывать.
 *
 * Границы (порог >= 2, окно — положительное целое) проверяются локально только
 * как очевидная подсказка; итоговую валидацию делает backend, и его ошибка
 * показывается как есть.
 */
const RecurrenceFields = ({ value, onChange, errors = {}, disabled = false, idPrefix = 'vio' }) => {
  const isCustom = value?.mode === RECURRENCE_CUSTOM;

  const setMode = (mode) => onChange({ ...value, mode });

  return (
    <fieldset className="vio-recurrence">
      <legend className="vio-drawer-section-title">Повторяемость</legend>

      <label className="vio-zone-scope-option">
        <input
          type="radio"
          name={`${idPrefix}-recurrence-mode`}
          checked={!isCustom}
          disabled={disabled}
          onChange={() => setMode(RECURRENCE_DEFAULT)}
        />
        <span>
          <strong>По умолчанию</strong>
          <span className="vio-field-hint">
            {`Порог ${BACKEND_DEFAULT_THRESHOLD} ${pluralRu(BACKEND_DEFAULT_THRESHOLD, EVENT_FORMS)}, окно подбирается автоматически`}
          </span>
        </span>
      </label>

      <label className="vio-zone-scope-option">
        <input
          type="radio"
          name={`${idPrefix}-recurrence-mode`}
          checked={isCustom}
          disabled={disabled}
          onChange={() => setMode(RECURRENCE_CUSTOM)}
        />
        <span>
          <strong>Настроить</strong>
        </span>
      </label>

      {isCustom && (
        <div className="vio-recurrence-custom">
          <div className="vio-field">
            <label className="vio-field-label" htmlFor={`${idPrefix}-recurrence-threshold`}>
              Порог, событий
            </label>
            <input
              id={`${idPrefix}-recurrence-threshold`}
              type="number"
              min="2"
              step="1"
              value={value.thresholdCount}
              disabled={disabled}
              onChange={(event) => onChange({ ...value, thresholdCount: event.target.value })}
            />
            {errors.thresholdCount && <p className="vio-field-error">{errors.thresholdCount}</p>}
          </div>

          <div className="vio-field">
            <label className="vio-field-label" htmlFor={`${idPrefix}-recurrence-window`}>
              Окно
            </label>
            <input
              id={`${idPrefix}-recurrence-window`}
              type="number"
              min="1"
              step="1"
              value={value.windowValue}
              disabled={disabled}
              onChange={(event) => onChange({ ...value, windowValue: event.target.value })}
            />
            {errors.windowValue && <p className="vio-field-error">{errors.windowValue}</p>}
          </div>

          <div className="vio-field">
            <label className="vio-field-label" htmlFor={`${idPrefix}-recurrence-unit`}>
              Единица окна
            </label>
            <select
              id={`${idPrefix}-recurrence-unit`}
              value={value.windowUnit}
              disabled={disabled}
              onChange={(event) => onChange({ ...value, windowUnit: event.target.value })}
            >
              {/* Неизвестная единица из ответа backend остаётся в состоянии как
                  есть: без этой опции select молча показал бы первую единицу. */}
              {!RECURRENCE_UNITS.includes(value.windowUnit) && (
                <option value={value.windowUnit} disabled>{UNKNOWN_UNIT_LABEL}</option>
              )}
              {RECURRENCE_UNITS.map((unit) => (
                <option key={unit} value={unit}>{RECURRENCE_UNIT_LABELS[unit]}</option>
              ))}
            </select>
            {errors.windowUnit && <p className="vio-field-error">{errors.windowUnit}</p>}
          </div>
        </div>
      )}
    </fieldset>
  );
};

export default RecurrenceFields;
